import React, { useContext, useEffect, useState } from 'react'
import Layout from '../Component/layout/main-layout'
// import aboutImg from '../Images/about.svg'
import UsefulCount from '../Component/useful-count'
import { useTranslation } from 'react-i18next'
import UsefulSite from '../Component/useful-site'
import layoutBgImg from '../Images/layout/others.jpg'
import { Context } from '../Store/context'
import { GetAbout } from '../api/Queries/get'
import Loading from '../Component/loader/loader'
import GlobalLayout from '../Component/layout/global-layout'

const AboutCourts = () => {
    const { t, i18n } = useTranslation()
    const [about, setAbout] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { showError } = useContext(Context);

    useEffect(() => {
        setIsLoading(true)
        const getNews = async () => {
            try {
                const data = await GetAbout()
                setIsLoading(false)
                setAbout(data[0] || null);
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getNews()
    }, [showError])


    const getDescription = (laws) => {
        const currentLang = i18n.language;
        let description = '';

        if (currentLang === 'ru') {
            description = laws.description_rus;
        } else if (currentLang === 'en') {
            description = laws.description_eng;
        } else {
            description = laws.description_tkm;
        }

        if (description) {
            description = description.replace(/(?:\r\n|\r|\n)/g, '</p><p class="mt-4">');
            description = '<p class="mt-4">' + description + '</p>';
        }

        return description;
    };


    return (
        <GlobalLayout
            title={`${t('about')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords='Kazyyet, Kazyyetin taryhy, Court, Sud, Суд, Верховный суд, Арбитражный суд'
        >
            <div className='mb-20'>
                <Layout
                    title={t('about')}
                    layoutBgImg={layoutBgImg}
                />
                <main className='mt-8 px-4 xxl:px-12 xxxl:px-32 xxxxl:px-64 
                            xxxxxl:px-[400px] xxxxxxl:px-[650px]
                            xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>
                    <section className='xl:flex xl:justify-between gap-8'>
                        <div className='xl:w-[70%]'>
                            {/* <img
                            src={aboutImg}
                            alt="court"
                            className='w-full object-contain rounded-lg'
                        /> */}
                            <div className='dark:text-dark-text'>
                                <h1 className='font-bold text-xl text-center'>
                                    {t('history')}
                                </h1>
                                {isLoading ? <Loading /> : <>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: document ?
                                                getDescription(about) : ''
                                        }}
                                        className='mt-4 leading-loose text-justify'
                                    />
                                </>}
                            </div>
                        </div>
                        <div className='mt-4 xl:mt-0 w-full
                                    xl:w-[30%] rounded-2xl'>
                            <UsefulCount />
                            <UsefulSite />
                        </div>
                    </section>
                </main>
            </div>
        </GlobalLayout>
    )
}

export default AboutCourts